import { render, staticRenderFns } from "./vue_jqxcombobox.vue?vue&type=template&id=1c0c1d9f"
import script from "./vue_jqxcombobox.vue?vue&type=script&lang=js"
export * from "./vue_jqxcombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports